import React from "react";
import { Checkbox } from "@mui/material";
import "./components.css";

export default function CheckboxComponent(props) {
  const { value, onChange, options, questionKey } = props;

  const handleAnswerChange = (event) => {
    const selectedValue = event.target.value;
    let newValue;

    if (value.includes(selectedValue)) {
      newValue = value.filter((v) => v !== selectedValue);
    } else {
      newValue = [...value, selectedValue];
    }

    onChange(questionKey, newValue);
  };

  return (
    <div className="checkbox-group">
    {options.map((option, index) => (
      <div className='checkbox-item'>
        <label key={index} className="checkbox-label">
          <Checkbox
            value={option.value}
            checked={value.includes(option.value)}
            onChange={handleAnswerChange}
            sx={{ '&.Mui-checked': { color: '#00634a' } }} />
          {option.text}
        </label>
      </div>
    ))}
  </div>
  );
}
